import React, { useEffect, useState } from "react";
import { Trash2, Plus, Hammer, SaveAll } from "lucide-react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import toast from "react-hot-toast";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const Vehicleservicetasks = ({
  workOrderDetail,
  tasks,
  setTasks,
  vehicleTaskDetails,
  setVehicleTaskDetails,
  setActiveTab,
  creationType,
  getVehicleTaskDetails,
  handleImageOpen,
  setCreationType,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [, setErrors] = useState({});

  const addRow = () => {
    setTasks([
      ...tasks,
      {
        description: "",
        panelDetails: "",
        attachements: [],
        cost: "",
        laborCost: "",
        discountAmount: "",
        discountPercentage: "",
        totalTaxPercentage: "",
        totalTaxAmount: "",
        totalCost: "",
        csgtPercentage : "",
        sgstPercentage : "",
      },
    ]);
  };

  const parseImages = (value) => {
    try {
      if (!value) return [];

      // If already array → return as is
      if (Array.isArray(value)) return value;

      // If it's a string → parse it
      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      // If parsed is array → return
      if (Array.isArray(parsed)) return parsed;

      // If it's a single object → wrap in array
      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  function ccyFormat(num) {
    return `${Number(num || 0).toFixed(2)}`;
  }

  const removeRow = (index) => {
    const updated = tasks.filter((_, i) => i !== index);
    setTasks(updated);
  };

  const validateStep1 = () => {
    let errors = {};

    if (!tasks[0].description) errors.description = "Description is required";
    if (!tasks[0].panelDetails)
      errors.panelDetails = "Panel Details is required";
    if (!tasks[0].attachements) errors.attachements = "Attachments is required";
    if (!tasks[0].cost) errors.cost = "Cost is required";
    // if (!tasks[0].laborCost) errors.laborCost = "Labor Cost is required";

    return errors;
  };

  const saveRow = async () => {
    const validationErrors = validateStep1();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all required fields");
      return;
    }

    setErrors({});

    let payload;

    if (creationType?.type === "new") {
      payload = {
        taskDescription: tasks[0].description,
        laborCost: Number(tasks[0].laborCost),
        totalCost: Number(tasks[0].totalCost || tasks[0].cost),
        panelDetails: tasks[0].panelDetails,
        attachments: JSON.stringify(tasks[0].attachements),
        logId: workOrderDetail?.id,
        sgstPercentage: tasks[0]?.sgstPercentage || 0,
        csgtPercentage: tasks[0]?.csgtPercentage || 0,
        totalTaxPercentage: tasks[0]?.totalTaxPercentage || tasks[0]?.totalTax,
        totalTax: tasks[0]?.totalTaxAmount,
        discountAmount: Number(tasks[0]?.discountAmount || 0),
        discountPercentage: Number(tasks[0]?.discountPercentage || 0),
      };
    } else {
      payload = {
        taskDescription: tasks[0].description,
        laborCost: Number(tasks[0].laborCost),
        totalCost: Number(tasks[0].totalCost || tasks[0].cost),
        panelDetails: tasks[0].panelDetails,
        attachments: JSON.stringify(tasks[0].attachements),
        logId: workOrderDetail?.id,
        id: creationType?.id,
        sgstPercentage: tasks[0]?.sgstPercentage || 0,
        csgtPercentage: tasks[0]?.csgtPercentage || 0,
        totalTaxPercentage: tasks[0]?.totalTaxPercentage || tasks[0]?.totalTax,
        totalTax: tasks[0]?.totalTaxAmount,
        discountAmount: Number(tasks[0]?.discountAmount || 0),
        discountPercentage: Number(tasks[0]?.discountPercentage || 0),
      };
    }

    toast.loading("Task details adding... Please wait", {
              id: "upload", // same ID to update later
              position: "top-center",
            });

    try {
      const res = await fetch(`${apiUrl}/api/vehicleservicetasks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.dismiss("upload")
        toast.success("Vehicle Service Task Added Successfully 🎉");
        setTasks([
          {
            description: "",
            panelDetails: "",
            attachements: [],
            cost: "",
            laborCost: "",
            discountAmount: "",
            discountPercentage: "",
            totalTaxPercentage: "",
            totalTaxAmount: "",
            totalCost: "",
            csgtPercentage : "",
            sgstPercentage : ""
          },
        ]);
        setCreationType({
          type: "new",
          id: null,
        });
        // setActiveTab("summary");
        await getVehicleTaskDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...tasks];
    const item = { ...updated[index], [field]: value };

    const parseNum = (v) => Number(v || 0);
    const isEmptyValue = (v) => v === "" || v === null || v === undefined;

    const serviceAmount = parseNum(item.cost);
    const discountAmount = parseNum(item.discountAmount);
    const discountPercentage = parseNum(item.discountPercentage);

    const getTaxableBase = (row) => {
      return (
        parseNum(row.cost) -
        parseNum(row.discountAmount) +
        parseNum(row.laborCost)
      );
    };
    const computeTaxAmount = (row) => {
      const percentage = parseNum(row.totalTaxPercentage || row.totalTax || 0);
      const base = getTaxableBase(row);
      return +((base * percentage) / 100);
    };

    if (field === "discountAmount") {
      const clampedAmount = serviceAmount
        ? Math.min(discountAmount, serviceAmount)
        : discountAmount;
      item.discountAmount = clampedAmount;
      item.discountPercentage = serviceAmount
        ? Number(((clampedAmount / serviceAmount) * 100).toFixed(2))
        : "";
    }

    if (field === "discountPercentage") {
      const clampedPercentage = Math.min(discountPercentage, 100);
      item.discountPercentage = clampedPercentage;
      item.discountAmount = serviceAmount
        ? Number(((clampedPercentage / 100) * serviceAmount).toFixed(2))
        : "";
    }

    if (field === "cost") {
      if (item.discountPercentage) {
        const clampedPercentage = Math.min(
          parseNum(item.discountPercentage),
          100,
        );
        item.discountPercentage = clampedPercentage;
        item.discountAmount = serviceAmount
          ? Number(((clampedPercentage / 100) * serviceAmount).toFixed(2))
          : "";
      } else if (item.discountAmount) {
        const clampedAmount = serviceAmount
          ? Math.min(discountAmount, serviceAmount)
          : discountAmount;
        item.discountAmount = clampedAmount;
        item.discountPercentage = serviceAmount
          ? Number(((clampedAmount / serviceAmount) * 100).toFixed(2))
          : "";
      }
    }

    if (field === "totalTaxPercentage" || field === "totalTax") {
      const currentValue = item.totalTaxPercentage || item.totalTax;
      const percentage = isEmptyValue(currentValue)
        ? ""
        : parseNum(currentValue);
      item.totalTaxPercentage = percentage;
      item.totalTax = percentage;
    }

    if (field === "totalTaxAmount") {
      const base = getTaxableBase(item);
      const amountValue = item.totalTaxAmount;
      const amount = isEmptyValue(amountValue) ? "" : parseNum(amountValue);
      const percentage =
        base > 0 && amount !== "" ? +((amount / base) * 100) : "";
      item.totalTaxPercentage =
        percentage === "" ? "" : Number(percentage.toFixed(2));
      item.totalTax = percentage === "" ? "" : Number(percentage.toFixed(2));
      item.totalTaxAmount =
        amount === ""
          ? ""
          : Number(amount.toFixed ? amount.toFixed(2) : amount);
    }

    if (field !== "totalTaxAmount") {
      const taxAmount = computeTaxAmount(item);
      item.totalTaxAmount = isFinite(taxAmount)
        ? Number(taxAmount.toFixed(2))
        : 0;
    }

    item.totalCost = Number(
      (getTaxableBase(item) + parseNum(item.totalTaxAmount)).toFixed(2),
    );

    updated[index] = item;
    setTasks(updated);
  };

  const handleFileChange = async (index, files) => {
    toast.loading("Image Upload Processing... Please wait", {
          id: "upload", // same ID to update later
          position: "bottom-center",
        });
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");
        toast.dismiss("upload")
    const uploaded = res?.uploaded || [];

    setTasks((prev) => {
      const updated = [...prev];

      updated[index].attachements = [
        ...(updated[index].attachements || []),
        ...uploaded,
      ];

      return updated;
    });
  };

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext))
      return "doc";

    return "other";
  };

  const task0 = tasks?.[0];

  useEffect(() => {
    if (!task0) return;

    setTasks((prev) => {
      const updated = [...prev];
      const current = { ...updated[0] };
      const cgst = Number(current.csgtPercentage || 0);
      const sgst = Number(current.sgstPercentage || 0);
      const explicitTotalTax = Number(
        current.totalTaxPercentage || current.totalTax || 0,
      );
      const totalTaxPercentage =
        cgst !== 0 || sgst !== 0 ? cgst + sgst : explicitTotalTax;
      current.totalTaxPercentage = totalTaxPercentage;
      current.totalTax = totalTaxPercentage;

      const serviceAmount = Number(current.cost || 0);
      const discountAmount = Number(current.discountAmount || 0);
      const laborCost = Number(current.laborCost || 0);
      const taxableBase = serviceAmount - discountAmount + laborCost;
      const totalTaxAmount =
        isFinite(taxableBase) && totalTaxPercentage !== ""
          ? (taxableBase * totalTaxPercentage) / 100
          : 0;
      current.totalTaxAmount = Number(totalTaxAmount.toFixed(2));
      current.totalCost = Number((taxableBase + totalTaxAmount).toFixed(2));

      updated[0] = current;
      return updated;
    });
  }, [
    task0,
    task0?.sgstPercentage,
    task0?.csgtPercentage,
    task0?.cost,
    task0?.laborCost,
    task0?.discountAmount,
    task0?.discountPercentage,
    setTasks,
  ]);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
          <Hammer className="text-blue-600 w-5 h-5" />
          Service Tasks
        </h2>

        <button
          type="button"
          onClick={addRow}
          disabled={tasks.length >= 1}
          className="text-sm bg-blue-600 text-white px-3 py-1.5 rounded-lg hover:bg-blue-700 transition flex items-center gap-1"
        >
          <Plus size={16} />
          Add Task
        </button>
      </div>

      <div className="space-y-3">
        {tasks.map((task, index) => (
          <div
            key={index}
            className="grid grid-cols-12 gap-3 items-center bg-gray-200 p-3 rounded-lg border border-gray-100"
          >
            <div className="col-span-3">
              <input
                type="text"
                placeholder="Task Description (e.g. Oil Change, Bumper Paint)"
                className="w-full border rounded-md p-2 text-sm"
                value={task.description}
                onChange={(e) =>
                  handleChange(index, "description", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="text"
                placeholder="Panel (e.g. Front Left Bumper, Engine)"
                className="w-full border rounded-md p-2 text-sm"
                value={task.panelDetails}
                onChange={(e) =>
                  handleChange(index, "panelDetails", e.target.value)
                }
              />
            </div>

            <div className="col-span-1">
              <input
                type="number"
                placeholder="Cost"
                className="w-full border rounded-md p-2 text-sm"
                value={task.cost}
                onChange={(e) => handleChange(index, "cost", e.target.value)}
              />
            </div>

            <div className="col-span-1">
              <input
                type="number"
                placeholder="Labor Cost"
                className="w-full border rounded-md p-2 text-sm"
                value={task.laborCost}
                onChange={(e) =>
                  handleChange(index, "laborCost", e.target.value)
                }
              />
            </div>

            {/* Discount Amount */}
            <div className="col-span-2">
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                  ₹
                </span>
                <input
                  type="number"
                  placeholder="Discount Amount"
                  value={task.discountAmount ?? ""}
                  onChange={(e) =>
                    handleChange(index, "discountAmount", e.target.value)
                  }
                  className="w-full h-11 border border-gray-300 rounded-lg pl-8 pr-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            {/* Discount Percentage */}
            <div className="col-span-2">
              <div className="relative">
                <input
                  type="number"
                  placeholder="Discount Percentage"
                  value={task.discountPercentage ?? ""}
                  onChange={(e) =>
                    handleChange(index, "discountPercentage", e.target.value)
                  }
                  className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                  %
                </span>
              </div>
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Total Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.totalCost}
                disabled
              />
            </div>

            <div className="col-span-2">
              {/* <label className="block text-xs font-medium text-gray-600 mb-1">
                Attachments
              </label> */}

              <div className="border-2 border-dashed border-gray-300 rounded-lg p-1 text-center hover:border-blue-500 transition">
                <input
                  type="file"
                  multiple
                  // accept="image/*"
                  className="hidden"
                  id={`file-${index}`}
                  onChange={(e) => handleFileChange(index, e.target.files)}
                />

                <label
                  htmlFor={`file-${index}`}
                  className="cursor-pointer text-sm text-blue-600"
                >
                  Click to upload Attachments
                </label>

                {/* <p className="text-xs text-gray-400 mt-1">PNG, JPG up to 5MB</p> */}
              </div>
              <div className="flex gap-2 mt-2 flex-wrap">
                {task.attachements?.map((file, i) => (
                  <div key={i} className="relative">
                    <img
                      src={file.url || file?.path || file?.Location || file}
                      alt="preview"
                      onClick={() => {
                        handleImageOpen(
                          file.url || file?.path || file?.Location || file,
                        );
                      }}
                      className="w-4 h-4 object-cover rounded-md border"
                    />

                    {/* <button
                      type="button"
                      onClick={() => removeImage(index, i)}
                      className="absolute -top-2 -right-2 bg-white border rounded-full text-red-500 px-1 text-xs"
                    >
                      ✕
                    </button> */}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-span-12">
              <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-sm font-semibold text-gray-800">
                      Tax Details
                    </h3>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  {/* CGST */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      CGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.csgtPercentage}
                        onChange={(e) =>
                          handleChange(index, "csgtPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* SGST */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      SGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.sgstPercentage}
                        onChange={(e) =>
                          handleChange(index, "sgstPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* Total Tax */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Total Tax (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.totalTaxPercentage ?? ""}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "totalTaxPercentage",
                            e.target.value,
                          )
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* Tax Amount */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Tax Amount (₹)
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                        ₹
                      </span>
                      <input
                        type="number"
                        value={task.totalTaxAmount ?? ""}
                        onChange={(e) =>
                          handleChange(index, "totalTaxAmount", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-8 pr-3 text-sm bg-green-50 font-medium"
                      />
                    </div>
                  </div>
                </div>

                {/* Summary */}
                <div className="mt-4 flex justify-end">
                  <div className="bg-gray-50 border rounded-lg px-4 py-2">
                    <span className="text-xs text-gray-500">GST Rate</span>
                    <div className="text-lg font-semibold text-blue-600">
                      {task.totalTaxPercentage || 0}%
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-span-1 text-center">
              <div className="flex gap-4">
                <button
                  type="button"
                  title="Delete"
                  onClick={() => removeRow(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  <Trash2 size={24} />
                </button>
                <button
                  type="button"
                  title="Save"
                  onClick={() => saveRow(index)}
                  className="text-green-500 hover:text-green-700"
                >
                  <SaveAll size={24} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Service Task Items
        </h2>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700, borderRadius: 10 }}>
            <TableHead>
              <TableRow>
                <TableCell>Task Description</TableCell>
                <TableCell>Panel Details</TableCell>
                <TableCell>Attachment</TableCell>
                <TableCell align="right">Cost</TableCell>
                <TableCell align="right">Labor Cost</TableCell>
                <TableCell align="right">Discount Amount</TableCell>
                <TableCell align="right">Discount Percentage</TableCell>
                <TableCell align="right">CGST Percentage</TableCell>
                <TableCell align="right">SGST Percentage</TableCell>
                <TableCell align="right">Total Tax Percentage</TableCell>
                <TableCell align="right">Total Tax</TableCell>
                <TableCell align="right">Total</TableCell>
                {/* <TableCell align="right">Action</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {vehicleTaskDetails?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.taskDescription || "-"}</TableCell>
                  <TableCell>{row.panelDetails || "-"}</TableCell>
                  <TableCell>
                    {parseImages(row?.attachments)?.length > 0 ? (
                      <div className="grid grid-cols-4 gap-2">
                        {parseImages(row?.attachments).map((file, index) => {
                          const url =
                            file?.path || file?.url || file?.Location || file;

                          const type = getFileType(url);

                          return (
                            <div
                              key={index}
                              className="w-10 h-10 flex items-center justify-center border rounded-lg overflow-hidden cursor-pointer bg-gray-50"
                              onClick={() => handleImageOpen(url)}
                            >
                              {type === "image" && (
                                <img
                                  src={url}
                                  alt="attachment"
                                  className="w-full h-full object-cover"
                                />
                              )}

                              {type === "video" && (
                                <video className="w-full h-full object-cover">
                                  <source src={url} />
                                </video>
                              )}

                              {type === "pdf" && (
                                <span className="text-xs text-red-500 font-semibold">
                                  PDF
                                </span>
                              )}

                              {type === "doc" && (
                                <span className="text-xs text-blue-500 font-semibold">
                                  DOC
                                </span>
                              )}

                              {type === "other" && (
                                <span className="text-xs text-gray-500">
                                  FILE
                                </span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  {ccyFormat(row.totalCost - row.totalTax)}
                  <TableCell align="right">
                    {ccyFormat(row.laborCost)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.discountAmount)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.discountPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.csgtPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.sgstPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalTaxPercentage)}
                  </TableCell>
                  <TableCell align="right">{ccyFormat(row.totalTax)}</TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalCost)}
                  </TableCell>
                  {/* <TableCell align="right">
                            <button
                              type="button"
                              title="Save"
                              onClick={() => {
                                setCreationType({ type: "edit", id: row.id });
                                setActiveTab("vehicleservicetasks");
                                setTasks([
                                  {
                                    description: row.taskDescription || "",
                                    panelDetails: row.panelDetails || "",
                                    attachements: JSON.parse(row.attachments) || [],
                                    cost: row.totalCost || "",
                                    laborCost: row.laborCost || "",
                                  },
                                ]);
                              }}
                              className="text-green-500 hover:text-green-700"
                            >
                              <Pencil size={24} />
                            </button>
                          </TableCell> */}
                </TableRow>
              ))}

              {/* <TableRow>
                        <TableCell
                          colSpan={4}
                          align="right"
                          sx={{ fontWeight: "bold" }}
                        >
                          Grand Total
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          {ccyFormat(grandTotalForTasks)}
                        </TableCell>
                      </TableRow> */}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default Vehicleservicetasks;
